<template>
  <div class="news TopHeadder">
      <!-- 新闻资讯 -->
      <div class="bannerBox">
          <img src="../../assets/image/banner-news.png" />
      </div>
      <div class="classBox">
          <ul>
              <li :class="{'current':current=='小语快讯'}" @click="tabClass('小语快讯')">公司新闻</li>
              <li :class="{'current':current=='行业资讯'}" @click="tabClass('行业资讯')">行业资讯</li>
              <li :class="{'current':current=='产品动态'}" @click="tabClass('产品动态')">产品更新</li>
          </ul>
      </div>
      <div class="newsBox">
        <ul class="ulType3">
            <li v-for="news in $store.state.newsList.newsData">
                <router-link :to="'/newsDetail/'+news.ID">
                    <img :src="'https://www.xiaoyu168.com'+news.PicturePath" class="li_pic">
                    <p class="li_tit" v-text="news.Title"></p>
                    <p class="li_txt" v-text="news.Depiction"></p>
                </router-link>
            </li>
        </ul>
      </div>
      <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router"
import Popup from "@/components/popup"
export default {
  name: 'news',
  data () {
    return {
        current:'小语快讯',
    }
  },
  components:{
     Popup
  },
  methods:{
    popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    },
  tabClass(className){
          this.current=className;
          this.$store.commit("newsList",className,1,100);
      }
  },
  mounted(){ 
        this.$store.commit("newsList","小语快讯",1,100);
  }
}
</script>


<style scoped>
    .classBox{
        width: 100%;
        height: 0.8rem;
    }
    .classBox ul{
        overflow: hidden;
        height: 0.8rem;
        width: 7.6rem;
        margin-left: -1px;
    }
    .classBox li{
        width: 2.5rem;
        height: 0.8rem;
        line-height:0.8rem;
        font-size:0.28rem;
        font-weight:bold;
        color:#fff;
        background: #6aa1fc;
        text-align: center;
        float: left;
        border-right:1px solid #fff;
    }
    .classBox li.current{
        background: #307eff;
    }
    .newsBox{
        padding:0.2rem 0 0.5rem;
    }
    .ulType3 li{
        height: 2.3rem;
    }
    .ulType3 li .li_pic{
        width: 2.8rem;
        height: 2.3rem;
    }
    .ulType3 li p{
        width: 3.68rem;
    }
    .ulType3 li .li_tit{
        text-overflow:ellipsis;
        white-space:nowrap
    }
</style>



// WEBPACK FOOTER //
// src/components/news/index.vue